

export default function NeedHelp() {
  return (
    <div className="w-full flex justify-center 11:hidden mt-2">
      <a className="underline color222"
      href='https://www.airbnb.com/help?audience=guest' target='_blank'>Need help?</a>
    </div>
  );
}
